module.exports = __webpack_public_path__ + "static/img/alert-header.f121947.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alert-header.png
// module id = 384
// module chunks = 36